// extracted by mini-css-extract-plugin
export default {"wrapper":"fB-z","viewport":"gB-z","container":"hB-z","slide":"iB-z"};